.navbar {
    width: 100%;
    height: 100%;
    padding: var(--mantine-spacing-sm);
    display: flex;
    flex-direction: column;
    background-color: var(--mt-brand-chrome);
}

.navbarMain {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.navLinks {
    gap: var(--mantine-spacing-xs);
}

.header {
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-sm);
    padding-bottom: var(--mantine-spacing-sm);
    margin-bottom: var(--mantine-spacing-md);
    border-bottom: 1px solid var(--mt-brand-chrome-divider);
    flex-shrink: 0;
}

.footer {
    padding-top: var(--mantine-spacing-md);
    margin-top: var(--mantine-spacing-md);
    border-top: 1px solid var(--mt-brand-chrome-divider);
    flex-shrink: 0;
}

.link {
    display: flex;
    align-items: center;
    width: 100%;
    text-decoration: none;
    font-size: var(--mantine-font-size-sm);
    line-height: var(--mantine-line-height-sm);
    color: var(--mt-brand-on-chrome);
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-md) !important;
    border-radius: var(--mantine-radius-md);
    font-weight: 600;

    &:hover {
        background-color: var(--mt-brand-chrome-hover);
        color: var(--mt-brand-on-chrome);

        .linkIcon,
        .linkLabel {
            color: var(--mt-brand-on-chrome);
        }
    }

    /* Active: orange marker and icon */
    &[data-active] {
        &,
        &:hover {
            box-shadow: inset 3px 0 0 var(--mt-brand-highlight);
            background-color: var(--mt-brand-chrome-active);
            color: var(--mt-brand-on-chrome-active);

            .linkLabel {
                color: var(--mt-brand-on-chrome-active);
            }

            .linkIcon {
                color: var(--mt-brand-highlight);
            }
        }
    }
}

.linkIcon {
    color: var(--mt-brand-on-chrome);
    margin-right: var(--mantine-spacing-sm);
    width: 18px;
    height: 18px;
    flex-shrink: 0;
}

.linkLabel {
    flex: 1;
    min-width: 0;
    color: var(--mt-brand-on-chrome);
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
}

.linkBadge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 5px;
    border-radius: var(--mantine-radius-xl);
    background-color: var(--mt-signal-attention);
    /* Navy on orange reads 5.7:1; white on this orange was 2.6:1 */
    color: var(--mt-brand-chrome);
    font-size: var(--mantine-font-size-xs);
    font-weight: 700;
    line-height: 1;
    flex-shrink: 0;
}

@media (max-width: 47.9375em) {
    .navbar {
        padding-top: var(--mantine-spacing-xs);
    }
}

@media (max-height: 600px) {
    .navbar {
        padding: var(--mantine-spacing-xs);
    }

    .header {
        padding-bottom: var(--mantine-spacing-xs);
        margin-bottom: var(--mantine-spacing-sm);
    }

    .footer {
        padding-top: var(--mantine-spacing-sm);
        margin-top: var(--mantine-spacing-sm);
    }

    .navLinks {
        gap: 2px;
    }

    .link {
        min-height: 32px;
        padding-top: 6px !important;
        padding-bottom: 6px !important;
    }
}
